import { type ComponentProps } from 'react';

import { Switch as ArkSwitch, type SwitchRootProps as ArkSwitchRootProps } from '@ark-ui/react';

import type { ActionColor, Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type SwitchProps = Omit<ArkSwitchRootProps, 'color'> & {
	size?: Scale3;
	variant?: 'classic' | 'surface' | 'soft';
	color?: ActionColor;
};

function SwitchRoot({
	className,
	size = '2',
	variant = 'surface',
	color = 'accent',
	children,
	...props
}: SwitchProps) {
	return (
		<ArkSwitch.Root
			className={cn('pt-switch', className)}
			data-size={size}
			data-variant={variant}
			data-accent-color={color}
			{...props}
		>
			{children}
		</ArkSwitch.Root>
	);
}

function SwitchControl({ className, ...props }: ComponentProps<typeof ArkSwitch.Control>) {
	return (
		<ArkSwitch.Control className={cn('pt-switch-control', className)} {...props}>
			<ArkSwitch.Thumb className="pt-switch-thumb" />
		</ArkSwitch.Control>
	);
}

function SwitchLabel({ className, ...props }: ComponentProps<typeof ArkSwitch.Label>) {
	return <ArkSwitch.Label className={cn('pt-switch-label', className)} {...props} />;
}

const Switch = Object.assign(SwitchRoot, {
	Root: SwitchRoot,
	Control: SwitchControl,
	Label: SwitchLabel,
	HiddenInput: ArkSwitch.HiddenInput
});

export { Switch, type SwitchProps };
